import React from 'react';
// Components
import ManageProductsTable from 'components/common/ManageProductsTable';

const ManageAthleteProducts: React.FC = () => {
  return <ManageProductsTable />;
};

export default ManageAthleteProducts;
